import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { ExperienceLevel, PoliJobsProposalDTO } from "../../Api";
import dayjs from "../../utils/dayjs-setup";
import { isUndefined } from "lodash";

export const AddPoliJobsProposalFormInit = (
	defaultValues?: PoliJobsProposalDTO
) => {
	const getDefaultValues = (initialData?: any) => {
		let defaultValues: any = {
			name: "",
			company: "",
			url: "",
			experienceLevel: ExperienceLevel.NotSpecified,
			location: "",
			numberOfPositions: 1,
			startingDate: dayjs(),
			availabilityAd: [dayjs(), dayjs().add(30, "days")],
		};

		if (!isUndefined(initialData)) {
			defaultValues = {
				...defaultValues,
				...initialData,
			};
		}

		return defaultValues;
	};

	defaultValues = getDefaultValues(defaultValues);
	const { t } = useTranslation();
	let schema = yup.object().shape({
		name: yup
			.string()
			.required(
				t("polijobs.addForm.requiredField", {
					field: t("polijobs.addForm.offerTitle"),
				})
			)
			.max(250, t("polijobs.addForm.nameLengthError")),
		description: yup.string(),
		company: yup.string().required(
			t("polijobs.addForm.requiredField", {
				field: t("polijobs.addForm.company"),
			})
		),
		url: yup.string().max(1000, t("polijobs.addForm.urlLengthError")),
		experienceLevel: yup.string().required(
			t("polijobs.addForm.requiredField", {
				field: t("polijobs.addForm.experienceLevel"),
			})
		),
		location: yup.string().required(
			t("polijobs.addForm.requiredField", {
				field: t("polijobs.addForm.location"),
			})
		),
		numberOfPositions: yup
			.number()
			.min(0)
			.required(
				t("polijobs.addForm.requiredField", {
					field: t("polijobs.addForm.numberOfPositions"),
				})
			)
			.typeError(t("polijobs.addForm.requiredNumber")),
		startingDate: yup.string().required(
			t("polijobs.addForm.requiredField", {
				field: t("polijobs.addForm.startingDate"),
			})
		),
		availabilityAd: yup.array().required(
			t("polijobs.addForm.requiredField", {
				field: t("polijobs.addForm.availabilityAd"),
			})
		),
	});

	const yupSync = {
		async validator({ field }: any, value: any) {
			await schema.validateSyncAt(field, { [field]: value });
		},
	};

	return { defaultValues, yupSync };
};
